import { Injectable } from '@angular/core';
import { ErrorDialogComponent } from '@shared/library/components/error-dialog/error-dialog.component';
import { InfoDialogComponent } from '@shared/library/components/info-dialog/info-dialog.component';
import { BaseDialogService } from '@shared/layout/services/base-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class DialogCustomService extends BaseDialogService {
  constructor() { 
    super();
  }

  public showErrorDialog( 
    type: 'info' | 'error',
    data?: any, 
    fnCancel?: Function, 
    fnOk?: Function
  ) {
    let componentSend!: any;

    switch (type) {
      case 'error':
        componentSend = ErrorDialogComponent;
        break;

      case 'info':
        componentSend = InfoDialogComponent;
        break;
    }

    return this.showDialog( '50vw', 'auto', componentSend, true, data, fnCancel, fnOk );
  }
}